"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapToDomainProduct = mapToDomainProduct;
function mapToDomainProduct(dto) {
    return {
        imgUrl: dto.imgUrl,
        purchaseCost: dto.purchaseCost,
        micronProductId: dto.micronProductId,
        code: dto.code,
        name: dto.name,
        description: dto.description,
        weight: dto.weight,
        retailPrice: dto.retailPrice,
        customCode: dto.customCode,
        thumbnailUrl: dto.thumbnailUrl,
        currency: dto.currency,
    };
}
